import { render, staticRenderFns } from "./historyTab.vue?vue&type=template&id=a11e734e&scoped=true&"
import script from "./historyTab.vue?vue&type=script&lang=js&"
export * from "./historyTab.vue?vue&type=script&lang=js&"
import style0 from "./historyTab.vue?vue&type=style&index=0&id=a11e734e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a11e734e",
  null
  
)

export default component.exports